import React from "react";
import classNames from "classnames/bind";
import styles from "./Setting.module.scss";

const cx = classNames.bind(styles);

export default function Setting({
  tabButtons,
  currentItem,
  form,
  changeItem,
  handleChange,
  handleSubmit,
}) {
  return (
    <>
      <div className={cx("tab_box")}>
        {tabButtons.map((tab, index) => (
          <button
            key={tab.id}
            onClick={() => changeItem(index)}
            className={cx(
              "tab_button",
              currentItem.id === tab.id && "tab_button_active"
            )}
          >
            {tab.tab}
          </button>
        ))}
      </div>
      <div className={cx("input_inner")}>
        <div className={cx("input_box")}>
          <label className={cx("label")}>상호명</label>
          <input
            type="text"
            placeholder="상호명"
            className={cx("input")}
            name="businessName"
            value={form.businessName || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>대표자</label>
          <input
            type="text"
            placeholder="대표자"
            className={cx("input")}
            name="ceoName"
            value={form.ceoName || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>주소</label>
          <input
            type="text"
            placeholder="주소"
            className={cx("input")}
            name="address"
            value={form.address || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={cx("input_inner")}>
        <div className={cx("input_box")}>
          <label className={cx("label")}>개인정보처리 책임자</label>
          <input
            type="text"
            placeholder="개인정보처리 책임자"
            className={cx("input")}
            name="privacyManager"
            value={form.privacyManager || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>사업자등록번호</label>
          <input
            type="text"
            placeholder="사업자등록번호"
            className={cx("input")}
            name="businessNumber"
            value={form.businessNumber || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>전화번호</label>
          <input
            type="text"
            placeholder="전화번호"
            className={cx("input")}
            name="phoneNumber"
            value={form.phoneNumber || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={cx("button_box")}>
        <button className={cx("button")} onClick={handleSubmit}>
          저장 하기
        </button>
      </div>
    </>
  );
}
